import {
  Smartphone, Laptop, Headphones, Shirt, ShoppingBag, Home, Sparkles, Plug,
  Car, Baby, Dumbbell, Gamepad2, ShoppingBasket, Paperclip, Wrench, PawPrint, Blocks,
  LayoutGrid,
} from "lucide-react";

export const ICONS = {
  Smartphone, Laptop, Headphones, Shirt, ShoppingBag, Home, Sparkles, Plug,
  Car, Baby, Dumbbell, Gamepad2, ShoppingBasket, Paperclip, Wrench, PawPrint, Blocks,
};

export const Icon = ({ name, ...props }) => {
  const C = ICONS[name] || LayoutGrid;
  return <C {...props} />;
};
